<template>
    <div class="fillcontain">
        <div class="table_container">
          <el-row v-if="plugin_msg != null">
            <el-alert
              :title="plugin_msg"
              type="error">
            </el-alert>
          </el-row>

            <el-table
                :data="tableData"
                style="width: 100%"
                v-loading="loading">
              <el-table-column
                label="桌号"
                prop="tables.number">
              </el-table-column>
              <el-table-column
                label="呼叫内容"
                prop="content">
              </el-table-column>
              <el-table-column
                label="状态"
                :formatter="statusFormat">
              </el-table-column>
              <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.status == 1"
                    size="mini"
                    @click="push(scope.row)">
                      重推给负责人
                  </el-button>
                  <el-button
                    v-if="scope.row.status == 1"
                    size="mini"
                    @click="handleStatusAlert(scope.row)">
                    处理
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="Pagination">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pages.page"
                  :page-size="pages.pageSize"
                  layout="total, prev, pager, next"
                  :total="pages.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                loading:false,
                call_tag:{
                    id:0,
                    content:"",
                    status:""+1,
                },
                dialog:{
                    dialogFormVisible:false,
                    title:"新增呼叫标签",
                    close:false,
                },
                pages:{
                    offset: 0,
                    pageSize: 10,
                    page: 1,
                    total: 0,
                },
              tableData: [],
              plugin_msg:null,
            }
        },
        created(){
            this.initData();
        },
        methods: {
            initData(){
              this.loading = true;
              var that = this;
              that.$api.get('/store/call_log', that.pages, response => {
                if (response.status >= 200 && response.status < 300) {
                  var res = response.data;
                  if (res.code == 0) {
                    that.tableData = res.data.callLogs.content;
                    that.plugin_msg = res.data.plugin_msg;
                    that.pages.total = res.data.callLogs.totalElements;
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }
                this.loading = false;
              });
            },

            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.pages.page = val;
                this.pages.offset = (val - 1)*this.pages.pageSize;
                this.initData()
            },
            statusFormat(row,column){
              return row.status == 2?"已处理":"未处理";
            },
            push(row) {
              this.loading = true;
              var that = this;
              that.$api.put('/store/call_log/'+row.id+"/push", null, response => {
                if (response.status >= 200 && response.status < 300) {
                  console.log(response.data);
                  var res = response.data;
                  if (res.code == 0) {
                    this.$message({
                      message: '重推成功',
                      type: 'success'
                    });
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }

              });

              this.loading = false;
            },

          handleStatusAlert(row) {
            this.$confirm('此操作将该呼叫记录修改为已处理, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.handleStatus(row);
            }).catch(() => {

            });
          },
          handleStatus(row) {
            this.loading = true;
            var that = this;
            that.$api.put('/store/call_log/'+row.id, {status:2}, response => {
              if (response.status >= 200 && response.status < 300) {
                console.log(response.data);
                var res = response.data;
                if (res.code == 0) {
                  this.$message({
                    message: '处理成功',
                    type: 'success'
                  });
                  this.loading = false;
                  this.initData();
                }else{
                  this.$message({
                    message: res.msg,
                    type: 'warning'
                  });
                }
              } else {
                this.$message({
                  message: "服务器维护中",
                  type: 'error'
                });
              }

            });
          },

        },
    }
</script>

<style lang="less">
	@import '../../style/mixin';
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .table_container{
        padding: 20px;
        text-align: left;
    }
    .Pagination{
        display: flex;
        justify-content: flex-start;
        margin-top: 8px;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }
    .avatar {
        width: 120px;
        height: 120px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/pages/store/CallLog.vue